import { useQuery } from '@tanstack/react-query';

import { Declaration } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useRetrieveFinalizeDeclarationsInfo = (id: string) =>
  useQuery({
    queryKey: ['retrieve-declaration-finalize', id],
    queryFn: async (): Promise<Declaration> => {
      try {
        const result = await apiClient.batchesFinalization.retrieveFinalizeDeclarationsInfo.query({ params: { id } });
        if (result.status !== 200) throw result.body;

        return result.body.declaration;
      } catch (error) {
        showErrorToast(error, 'Error fetching the finalize declarations info!');
      }
    },
    enabled: !!id,
  });
